var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightArrowFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / 18 / Outline / Arrow-Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M12 6.00016L7.43978 10.5604L6.56995 9.69054L9.66348 6.59701L0 6.59701V5.40425L9.66443 5.40425L6.56995 2.30977L7.43978 1.43994L12 6.00016Z",
    fill: "var(--secondary-4)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowFilled);
export default __webpack_public_path__ + "static/media/rightArrowFilled.aff0df372829f80ee2ff302f133ab993.svg";
export { ForwardRef as ReactComponent };